import axios from "axios";
import { API_URL } from "../../utils/ApiUrl";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { getStatus } from "../../helperFunction/status";

function useFetchTaskData(taskData, id, setTaskData, setLoader, account) {
    const navigate = useNavigate();
    const [curruntStatus, setCurruntStatus] = useState();
    const [isWinner, setIsWinner] = useState(false)
    // Utility function to retrieve access token and return the config
    const getAuthConfig = () => {
        const accessToken = localStorage.getItem("accessToken");
        return accessToken
            ? { headers: { Authorization: `Bearer ${accessToken}` } }
            : {};
    };

    const fetchTaskData = async () => {
        try {
            setLoader(true);
            const config = getAuthConfig(); // Fetch auth config
            const response = await axios.get(`${API_URL}tasks/${id}`, config);

            setTaskData(response?.data?.data);
            setLoader(false);
        } catch (error) {
            setLoader(false);
            console.error("Error fetching task data:", error);
            navigate("/error404"); // Redirect on error
        }
    };
    useEffect(() => {
        if (taskData) {
            if (taskData?.status === 'completed') {
                taskData.isClaimed = true
            } else {
                taskData.isClaimed = false
            }

            const status = getStatus(taskData, 'taskDetail');
            setCurruntStatus(status);
            // console.log(status, 'setCurruntStatussetCurruntStatus');
        }
    }, [taskData])
    useEffect(() => {
        if (id && isNaN(id)) {
            navigate("/error404")
            //  <Navigate to= />;
        }
    }, [id])
    useEffect(() => {
        if (taskData && account) {
            if (taskData?.participants?.[0]?.status === 'winner' && taskData?.participants?.[0]?.user?.walletAddress?.toLowerCase() === account?.toLowerCase()) {
                setIsWinner(true)
            } else {
                setIsWinner(false)
            }
        }

    }, [taskData, account])
    useEffect(() => {
        if (id) {
            fetchTaskData(); // Only fetch when ID is valid
        }

        window.scrollTo(0, 0); // Scroll to top on mount or dependency change
    }, [id]); // Dependency on ID, uniqueCode, and apiReload

    return { curruntStatus, isWinner, fetchTaskData }; // Expose the function if needed outside the hook
}

export default useFetchTaskData;
